import React, { useState, useEffect } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { SelectChangeEvent } from '@mui/material';
import cn from 'clsx';
import { TextComponent, SelectComponent } from '../uiComponents';
import { gritComponentStyles } from './gritComponentStyles';
import { getSelfAssertedProfiles, getOtherProfiles } from '../../store';
import { useSelector } from 'react-redux';
import { NonInteractiveTechnicalProfile, SelfAssertedProfile } from '../../xmlParsing/interfaces';
import CONSTANTS from '../../constants/constants';
import { init_NonInteractiveTechnicalProfile, init_SelfAssertedProfile } from '../../xmlParsing/initInterfaces';

interface AddTechnicalProfileComponentProps {
  data: SelfAssertedProfile | NonInteractiveTechnicalProfile;
  addHandler: (data: any) => void;
  disableSubmit: (data: any) => void;
}

function AddTechnicalProfileComponent({ data, addHandler, disableSubmit }: AddTechnicalProfileComponentProps) {
  const [modifiedData, setModifiedData] = useState<any>(data);
  const [tpType, setTpType] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('ID cannot be empty.');
  const classes = gritComponentStyles();
  const selfAssertedProfiles = useSelector(getSelfAssertedProfiles);
  const otherProfiles = useSelector(getOtherProfiles);
  const tpTypes = Object.keys(CONSTANTS.TECHNICAL_PROFILES).reduce(
    (acc: any, key: string) =>
      // @ts-ignore
      acc.concat({ label: CONSTANTS.TECHNICAL_PROFILES[key]['name'], value: key }),
    [],
  );
  useEffect(() => {
    tpType === '' && setTpType(tpTypes[0]['value']);
  }, [tpTypes]);

  useEffect(() => {
    if (tpType) {
      let _initData = {};
      if (tpType === 'selfAssertedProfiles') {
        _initData = init_SelfAssertedProfile();
      } else {
        _initData = init_NonInteractiveTechnicalProfile();
      }
      const _obj = {
        // @ts-ignore
        displayName: CONSTANTS.TECHNICAL_PROFILES[tpType]['displayName'] || '',
        // @ts-ignore
        protocol: CONSTANTS.TECHNICAL_PROFILES[tpType]['protocol'] || ['', ''],
        // @ts-ignore
        claimProvider: CONSTANTS.TECHNICAL_PROFILES[tpType]['claimProvider'] || '',
        // @ts-ignore
        metadata: CONSTANTS.TECHNICAL_PROFILES[tpType]['metadata'] || [],
      };
      setModifiedData({ ..._initData, ..._obj, tpType });
    }
  }, [tpType]);

  useEffect(() => {
    setModifiedData(data);
  }, [data]);

  useEffect(() => {
    addHandler(modifiedData);
    validateSubmitButton(modifiedData, 'id');
  }, [modifiedData]);

  useEffect(() => {
    !!errorMsg ? disableSubmit(true) : disableSubmit(false);
  }, [errorMsg]);

  const validateSubmitButton = (
    modifiedData: SelfAssertedProfile | NonInteractiveTechnicalProfile,
    attribute: string = '',
  ) => {
    if (attribute === 'id') {
      if (modifiedData[attribute].trim() === '') {
        setErrorMsg('ID cannot be empty.');
      } else if (!/^[a-zA-Z0-9]+[a-zA-Z0-9_-]{0,}$/.test(modifiedData[attribute])) {
        setErrorMsg(
          'Should begin with an alphabet or number and can contain alphabets, numbers and the following symbols: _ -',
        );
      } else if (
        Object.keys(selfAssertedProfiles).findIndex(
          (el: string) => el.trim().toLowerCase() === modifiedData[attribute].trim().toLowerCase(),
        ) >= 0
      ) {
        setErrorMsg('A self asserted profile with the same ID exists.');
      } else {
        setErrorMsg('');
      }
    }
  };
  return (
    <>
      {modifiedData && (
        <div className={cn(classes.flexCol)}>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<any>) => {
              setTpType(e.target.value);
            }}
            data={{
              value: tpType,
              label: 'Technical Profile Type',
              options: tpTypes,
            }}
          />
          <div className={classes.flexRow}>
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setModifiedData({ ...modifiedData, id: e.target.value });
              }}
              data={{
                value: modifiedData['id'],
                helperText: errorMsg,
                error: !!errorMsg,
                label: 'ID',
              }}
            />
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setModifiedData({ ...modifiedData, displayName: e.target.value });
              }}
              data={{
                value: modifiedData['displayName'],
                label: 'Display Name',
              }}
            />
          </div>
          <div className={classes.flexRow}>
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setModifiedData({ ...modifiedData, domain: e.target.value });
              }}
              data={{
                value: modifiedData['domain'],
                label: 'Domain',
              }}
            />
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setModifiedData({ ...modifiedData, description: e.target.value });
              }}
              data={{
                value: modifiedData['description'],
                label: 'description',
              }}
            />
          </div>
          {/* <div className={classes.flexRow}>
            <MetadataGeneratorComponent
              metadata={CONSTANTS.getMetaData(tpType)}
              // @ts-ignore
              data={CONSTANTS.TECHNICAL_PROFILES[tpType]["metadata"]}
              changeHandler={(data: any) => {
                console.log('...data........... :', data);
              }}
            />
          </div> */}
        </div>
      )}
    </>
  );
}

// export default withAITracking(reactPlugin, AddTechnicalProfileComponent);
export default AddTechnicalProfileComponent;
